import React, { useContext, useState } from 'react';
import {
  Flex,
  InputSearch,
  PaginationPerPageSelect,
  Button,
  SearchContext,
  ModalContext,
} from 'dash-ui';
import { useTranslation } from 'react-i18next';

import { OrganizationUsersModalsEnum } from 'pages/organizations/OrganizationDetailsPage/components/OrganizationDetailsTabs/components/OrganizationUsers/constants/constants';

function OrganizationUsersTableHeader() {
  const { t } = useTranslation('tables', {
    keyPrefix: 'organizationUsers',
  });
  const { t: tLabels } = useTranslation('common', { keyPrefix: 'labels' });
  const { setSearchSlug } = useContext(SearchContext);
  const [search, setSearch] = useState('');
  const { toggleModal } = useContext(ModalContext);
  return (
    <>
      <Flex
        w="100%"
        px={6}
        py={4}
        justifyContent="space-between"
        flexDirection="row"
        flex={1}
      >
        <Flex flex={1} flexDirection="row">
          <InputSearch
            w="100%"
            onClear={() => {
              setSearch('');
              setSearchSlug('');
            }}
            value={search}
            placeholder={t`searchInputPlaceholder` || ''}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setSearch(event.target.value);
              setSearchSlug(event.target.value);
            }}
          />
        </Flex>
        <Flex>
          <PaginationPerPageSelect label={`${tLabels`show`} `} w={130} mx={4} />
          <Button
            icon="plus"
            px={5.5}
            onClick={() =>
              toggleModal(
                true,
                OrganizationUsersModalsEnum.SAVE_ORGANIZATION_USER
              )
            }
          >{t`addNewButtonLabel`}</Button>
        </Flex>
      </Flex>
    </>
  );
}

export default OrganizationUsersTableHeader;
